import { Popover, PopoverItem } from "./v2";

// TP-Coach-Mandate — staff variant of PlayerCardPopover (cloned, not
// shared, so the player path stays byte-identical). My Agency V2 restyle
// (CMP-POPOVER chrome, same as the players menu). WIRING UNCHANGED
// (Rule 7): single "Change Agent" action → onChangeAgent(member);
// outside-click close comes from the shared Popover (same listener idiom
// as the old inline effect). The grid gates rendering of the 3-dot menu
// itself (F5 — only mandated members).
const StaffCardPopover = ({ isOpen, onClose, member, onChangeAgent }) => {
  if (!isOpen) return null;

  return (
    <Popover
      onClose={onClose}
      width={192}
      className="absolute right-4 top-[46px] z-50"
    >
      <PopoverItem
        onClick={() => {
          onChangeAgent(member);
          onClose();
        }}
      >
        Change Agent
      </PopoverItem>
    </Popover>
  );
};

export default StaffCardPopover;
